/* The profile icon's small panel (snippets/swrfm-account-panel.liquid, 2026-10-15).
   The panel is a native <details>, so it already opens and closes with a tap, a click, Enter or Space.
   This adds what <details> lacks: one open at a time, closing on a tap outside, on Escape (focus goes
   back to the icon) and when keyboard focus leaves it. Delegated on the document so the sticky
   header's copy of the markup works without a binding of its own. */
(function () {
  if (window.SWRFM_ACCT) return;
  window.SWRFM_ACCT = true;

  var SELECTOR = 'details[data-swrfm-acct]';
  function openOnes() { return document.querySelectorAll(SELECTOR + '[open]'); }
  function closeAll(except) {
    openOnes().forEach(function (d) { if (d !== except) d.removeAttribute('open'); });
  }

  // One open at a time ('toggle' does not bubble; a capturing listener still sees it).
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches(SELECTOR) && d.open) closeAll(d);
  }, true);

  // A tap or click anywhere outside an open panel closes it.
  document.addEventListener('click', function (e) {
    var inside = e.target.closest && e.target.closest(SELECTOR);
    closeAll(inside);
  });

  // Escape closes it and puts focus back on the icon.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    openOnes().forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s && d.contains(document.activeElement)) s.focus();
    });
  });

  // Tabbing past the last link closes it.
  document.addEventListener('focusout', function (e) {
    var d = e.target.closest && e.target.closest(SELECTOR);
    if (!d || !d.open) return;
    var next = e.relatedTarget;
    if (next && !d.contains(next)) d.removeAttribute('open');
  });
})();
